// @ts-nocheck - suppress strict/type resolution errors in this legacy JS-heavy file
/// <reference path="../../typings/global.d.ts" />

import { ErrorHandler } from "../../common/ErrorHandler"; 

export class ShoppingCart {

    public static Init(): void {
        $(".icf-cart-item-delete").on('click', (e) => {
            var url: string = e.currentTarget.getAttribute("href");
            ShoppingCart.DeleteCartItem(url);
            return false;
        });
    }

    private static DeleteCartItem(url: string): void {

        if (!window.confirm("Are you sure you want to delete this item?")) {
            return;
        }

        var jqxhr = $.post(url, (result) => {
            //alert("success - " + JSON.stringify(result));
            if (result.IsJsonResponse) {
                //Possible session timeout
                if (result.RedirectUrl) {
                    window.location.href = result.RedirectUrl
                }
            } else {
                //FIXME
                //reloads form with new html
                //    $("#eligibility-form-div").html(result);
                //    var errorDiv = $('.field-validation-error:visible').first();
                //    var scrollPos = errorDiv.offset().top;
                //    $(window).scrollTop(scrollPos);
            }
        }).fail(function (xhr) {
            ErrorHandler.HandleError(xhr, false);
        });
    }
}